// extracted by mini-css-extract-plugin
export default {"ProductContainer":"DMYowtniBHg_lzBYUz8E"};